import {ref, unref, shallowRef, computed, onMounted} from 'vue'
import { CRUISE_OPTYPE_ADULT , CRUISE_OPTYPE_CHILD, CRUISE_OPTYPE_INFANT, STATUS_ADL } from '@/tourist/tourist-store.js'
import {formatPrice} from '@/util.js'

/***************
 * УДАЛЮ ФАЙЛИК
 */

export default function useCruiseOrderCheck(persIn, CabinsIn, customerIn, skipCabinCheck = false) {

    let pers = unref( persIn )
    let Cabins = unref( CabinsIn )
    let customer = unref( customerIn )
    let ret=[]

    // проверяем что есть туристы, есть каюты и они валидны
    const errors=[]
    if (!skipCabinCheck && !Cabins.length) {
        errors.push({text: 'не выбрана каюта'})
    }
    if (!pers.length) {
        errors.push({text: 'не выбраны туристы'})
    }
    let personInd = 1
    for (let person of pers) {
        if (!person.vest.isValid) {
            let text = person.vest.testCount ? `поправьте данные пассажира ${personInd}` : `заполните данные пассажира ${personInd}`
            errors.push({text})
        }
        personInd++
    }
    if (!customer.vest.isValid) {
        let text = customer.vest.testCount ? `поправьте заказчика` : `заполните заказчика`
        errors.push({text})
    }

    if (errors.length) {
        ret=errors // размещение в каюте имеет смысл проверять только когда все правильно заполнено
    } else if (!skipCabinCheck) {
        // проверяем что каждая каюта правильно заполнена
        ret = Cabins.reduce( (errs, {Cabin, order})=>{
            let type= ''
            const room_val= order.toString()
            let {with_place, adl, inf} = pers.filter( person => person.room.val === room_val ).reduce ( (ob, {tt}) => {
                if (CRUISE_OPTYPE_ADULT === tt.optype ) {
                    ob.with_place++
                    ob.adl++
                }
                if (CRUISE_OPTYPE_CHILD === tt.optype) {
                    ob.with_place++
                }
                if (CRUISE_OPTYPE_INFANT === tt.optype) {
                    ob.inf++
                }
                return ob
            }, { with_place:0, adl:0, inf:0 }  )

            const n_max = Cabin.acc.main + Cabin.acc.additional
            const n_min = 1
            if (!(with_place <= n_max)) {
                errs.push( {text: `ввели слишком много пассажиров, максимум ${n_max}`, type})
            }
            if (!(with_place >= n_min)) {
                errs.push( {text: `введите хотя бы одного пассажира с местом`}, type)
            }
            if (!(adl >= 1)) {
                errs.push( {text: `в каюте должен быть хоть один взрослый`}, type)
            }
            if (!(adl >= inf)) {
                errs.push( {text: `детей без места должно быть не больше чем взрослых`}, type)
            }
            return errs
        }, [] )
    }
    return ret

}

const dmy2ymd = d => {
    let p = d.split('.')
    return `${p[2]}-${p[1]}-${p[0]}`
}

export const getBookData = (persIn, room_optionsIn, customerIn) => {
    let pers = unref( persIn )
    let room_options = unref( room_optionsIn )
    let customer0 = unref( customerIn )
    let passengers0 =[customer0, ...pers].map( person => {
        let isCust = person.isCust

        let field

        let cabin_id = null
        if (!isCust) {
            field = person.room
            cabin_id = room_options.find( opt => opt.id === field.val ).cabinId
        }

        let passenger_type = null
        if (!isCust) {
            passenger_type = person.tt.status 
        }

        let male = person.male.val
        let birthday = dmy2ymd(person.born.val)

        let last_name = person.fname.val
        let first_name = person.iname.val
        let middle_name = person.oname.val

        let last_lname = ''
        let first_lname = ''
        let middle_lname = ''

        if (!isCust) {
            last_lname = person.flname.val
            first_lname = person.ilname.val
            middle_lname = ''
        }

        let doc_type = person.doc_type.val

        let doc_issue = dmy2ymd(person.doc_issue.val)
        let doc_valid = 'zps' === person.doc_type.val ? dmy2ymd(person.doc_valid.val) : ''


        let doc_series = person.doc_serie.val
        let doc_number = person.doc_number.val
        let country = person.doc_gra.val

        let phone = ''
        let email = ''
        let address = ''
        let punitcode = ''
        let pauthority = ''
        if (isCust) {
            phone = person.phone.val
            email = person.email.val
            address = person.doc_address.val
            punitcode = person.doc_unitcode.val
            pauthority = person.doc_authority.val
        }
        return !isCust ? {
            cabin_id, passenger_type, 
            last_name, first_name, middle_name, 
            last_lname, first_lname, middle_lname,
            male, birthday,
            doc_type, doc_series, doc_number, doc_issue, doc_valid, country
        } : {
            last_name, first_name, middle_name, 
            male, birthday,
            doc_type, doc_series, doc_number, doc_issue, doc_valid, country,
            phone, email, address, punitcode, pauthority,
        }
    } )
    let [customer, ...passengers] = passengers0
    let comment = customer0.note.val
    return {passengers, customer, comment}
}


const toflo = sum => {
    if ("string" === typeof(sum)) {
        sum = sum.replace(/[^0-9,.]/g,'')
        sum = sum.replace(/,/g,'.')
        sum = parseFloat(sum, 10)
    }
    return sum
}
export const book_sumV = (calc_prices) => {
    let vals = Object.values( calc_prices )
    let ret = { v: ['', 1] } // нет суммы
    if ( vals.length ) {
        let sums = vals.map( ({v:[p,c]}) => toflo(p)  )
        let price = sums.reduce( (akk, sum) => akk + sum, 0 )
        let currency = vals[0].v[1]
        ret= {v: [price, currency]}
    }
    return ret
}
